import styled from "styled-components"

const RendezVousSubContainer = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`

const RendezVousTitle = styled.h2`
  &::after {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

const RendezVousInputType = styled.input`
  & + div span:first-of-type:before {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    box-shadow: 0 0 0 0.18em ${(props) => props.theme.a_color_gradients.a_dark};
  }
  &:focus + div span:first-of-type:before {
    box-shadow: 0 0 0 0.18em ${(props) => props.theme.a_color_gradients.a_dark},
      0 0 0 0.36em black;
  }
`

const StepIcon = styled.div`
  border: 4px solid
    ${(props) =>
      props.active || props.isDone
        ? props.theme.b_color_gradients.b_dark
        : props.theme.c_color_gradients.c_medium};
  color: ${(props) =>
    props.active || props.isDone
      ? "black"
      : props.theme.c_color_gradients.c_medium};
  background-color: ${(props) =>
    props.active ? props.theme.b_color_gradients.b_dark : "white"};
`

const StepLine = styled.div`
  background-color: ${(props) =>
    props.active || props.isDone
      ? props.theme.b_color_gradients.b_dark
      : props.theme.c_color_gradients.c_medium};
`

const RendezVousPart3Delete = styled.button`
  border-right: 3px solid ${(props) => props.theme.c_color_gradients.c_medium};
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const RendezVousPart3Add = styled.button`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const RendezVousPart4Input = styled.input`
  &:focus {
    outline: 3px solid black;
  }
`

const RendezVousPart4TextArea = styled.textarea`
  &:focus {
    outline: 3px solid black;
  }
`

const RendezVousPart5WeekButton = styled.button`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const RendezVousPart5WeekDate = styled.div`
  &::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

const RendezVousPart5WeekDateJourNombre = styled.div`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const RendezVousPart5CreneauxDispos = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  &:hover {
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
const RendezVousPart5CreneauxDisposChoisi = styled.div`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
  border: 4px solid ${(props) => props.theme.b_color_gradients.b_dark};
`

export {
  RendezVousSubContainer,
  RendezVousTitle,
  RendezVousInputType,
  StepIcon,
  StepLine,
  RendezVousPart3Delete,
  RendezVousPart3Add,
  RendezVousPart4Input,
  RendezVousPart4TextArea,
  RendezVousPart5WeekButton,
  RendezVousPart5WeekDate,
  RendezVousPart5WeekDateJourNombre,
  RendezVousPart5CreneauxDispos,
  RendezVousPart5CreneauxDisposChoisi,
}
